import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import axios from "axios";
import fondo from "../../Web Mundo/fondoInicio.png";
import { Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useDispatch } from "react-redux";

import { signin } from "../../keychain/login";
import { login, setInformacion } from "../../storage/slices/usuarios";
import { rutas } from "../../rutas/rutas";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const Login = () => {
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const parametros = useParams();

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  const handleForm = (e) => {
    setUsuario(e.target.value);
  };

  useEffect(() => {
    // Si ya existe token en sessionStorage, lo deja listo para axios
    const token = sessionStorage.getItem("token");

    if (token) {
      axios.defaults.headers.common["token"] = token;
    }
  }, []);

  const guardarSesion = ({ token, user, infoUser }) => {
    if (!token) {
      handleClick();
      return false;
    }

    // Guardar token para llamadas protegidas
    sessionStorage.setItem("token", token);

    // Guardar usuario con token
    sessionStorage.setItem(
      "user",
      JSON.stringify({
        user,
        logged: true,
        token,
      })
    );

    // Axios enviará token automáticamente en próximas peticiones
    axios.defaults.headers.common["token"] = token;

    // Cookie normal. OJO: no es httpOnly porque se crea desde frontend.
    document.cookie = `token=${token}; max-age=${3600 * 12}; path=/; samesite=strict; secure;`;

    dispatch(
      login({
        user,
      })
    );

    dispatch(setInformacion(infoUser?.resultado));

    navigate("/game", {
      replace: true,
    });

    return true;
  };

  const handleLogin = (infoUser, tokenExterno = null) => {
    if (usuario === "" || usuario.length < 3) {
      handleClick();
      return;
    }

    const token = tokenExterno || infoUser?.token;

    guardarSesion({
      token,
      user: usuario,
      infoUser,
    });
  };

  const handleLoginPass = () => {
    if (
      usuario.length < 4 ||
      usuario.length > 19 ||
      password.length < 4 ||
      password.length > 15
    ) {
      handleClick();
      return;
    }

    axios
      .post(rutas.loginPass, {
        user: usuario,
        password: password,
      })
      .then((res) => {
        const token = res.data?.token;

        if (!token) {
          handleClick();
          return;
        }

        guardarSesion({
          token,
          user: usuario,
          infoUser: res.data,
        });
      })
      .catch((err) => {
        handleClick();
      });
  };

  const handleLoginKeychain = () => {
    if (usuario === "" || usuario.length < 3) {
      handleClick();
      return;
    }

    /*
      IMPORTANTE:
      Esta parte depende de cómo esté hecho "../../keychain/login".

      Si signin devuelve token dentro de infoUser.token, funcionará.
      Si KeyChain no devuelve token, la mascota seguirá dando 401.
    */
    signin(
      usuario,
      (infoUser) => {
        const token = infoUser?.token;

        if (!token) {
          console.warn("KeyChain login no devolvió token:", infoUser);

          // Mantengo tu comportamiento anterior para no romper KeyChain.
          dispatch(
            login({
              user: usuario,
            })
          );

          dispatch(setInformacion(infoUser?.resultado));

          sessionStorage.setItem(
            "user",
            JSON.stringify({
              user: usuario,
              logged: true,
            })
          );

          navigate("/game", {
            replace: true,
          });

          return;
        }

        guardarSesion({
          token,
          user: usuario,
          infoUser,
        });
      },
      parametros
    );
  };

  const styleContainer = {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const styleCard = {
    width: "450px",
    height: "450px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    background: "rgba(106, 175, 255, 0.2)",
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        backgroundImage: `url(${fondo})`,
        backgroundSize: "cover",
      }}
    >
      <Box sx={styleContainer}>
        <Box sx={styleCard}>
          <Box
            component="form"
            sx={{
              height: "70%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "column",
            }}
            noValidate
            autoComplete="off"
          >
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                color: "white",
              }}
            >
              Login with your user
            </Typography>

            <TextField
              sx={{ color: "white" }}
              onChange={handleForm}
              label="Username"
              variant="outlined"
              autoComplete="username"
            />

            <TextField
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              label="Password"
              variant="outlined"
              autoComplete="current-password"
            />

            <Box
              sx={{
                width: "90%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button onClick={handleLoginPass} variant="contained">
                Log in
              </Button>

              <Button onClick={handleLoginKeychain} variant="contained">
                KeyChain
              </Button>
            </Box>
          </Box>

          <Stack spacing={2} sx={{ width: "100%" }}>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
              <Alert
                onClose={handleClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                There was an error loading the data
              </Alert>
            </Snackbar>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};